import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';

/**
 * 検索枠での人数の増減 制御
 */
export default class PassengerCountClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'PassengerCountClass';

    this.EVENT_CLICK_PLUS = 'eventClickPlus';
    this.EVENT_CLICK_MINUS = 'eventCliskMinus';
    this.EVENT_CHANGE = 'eventChange';

    this.target = _target;
    this.isAdult = true;

    this.onClickPlusListener = this.onClickPlus.bind(this);
    this.onClickMinusListener = this.onClickMinus.bind(this);

    // デフォルト値
    this.n = 0;
    // 最少人数
    this.minNum = 0;

    this.isDisable = false;
  }

  onCreate() {
    super.onCreate();

    this.count = $('.n', this.target);
    // console.log(this.name,this.target);

    if (this.isAdult) {
      this.n = 1;
    }

    this.onCountChange(this.n);

    $('.plus', this.target).on('click', this.onClickPlusListener);
    $('.minus', this.target).on('click', this.onClickMinusListener);
  }

  onClickPlus(e) {
    e.preventDefault();

    this.jq.trigger(this.EVENT_CLICK_PLUS);
    // this.onCountChange(this.n + 1);
  }

  onClickMinus(e) {
    e.preventDefault();
    this.jq.trigger(this.EVENT_CLICK_MINUS);
    // this.onCountChange(this.n - 1);
  }

  onAdd(_n = 1) {
    this.onCountChange(this.n + _n);
  }

  onCountChange(_n, _isNoneEvent) {
    if (_n < this.minNum) { _n = this.minNum; }
    if (this.n === _n) { return; }
    this.count.text(_n);
    this.n = Number(_n);

    if (!_isNoneEvent) { this.jq.trigger(this.EVENT_CHANGE); }
  }
}
